import interpolateComponents from '@automattic/interpolate-components';

import { ApiISODateTimeString } from 'api/types/ApiTypedDate';
import { FormUsageContext } from 'components/Form/Form';
import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';
import { BodySmall } from 'components/Text/BodySmall';
import { H3 } from 'components/Text/H3';
import { CareerPathForm } from 'modules/salaries/components/CareerPathForm/CareerPathForm';
import { CareerPathAnalyticsData } from 'modules/salaries/types/CareerPathAnalyticsData';
import { EstimatedRange } from 'modules/salaries/types/EstimatedRange';
import { colors } from 'theme/theme';

import {
  CareerPathChartHeaderContainer,
  CareerPathFormContainer,
} from './CareerPathChartHeader.styled';

type CareerPathChartHeaderProps = {
  formAnalyticsTitle: string;
  formUsageContext: FormUsageContext;
  analyticsData: CareerPathAnalyticsData;
  careerPathData: EstimatedRange[];
  salaryModelCreated: ApiISODateTimeString;
  setCareerPathData: (careerPath: EstimatedRange[]) => void;
  searchApiKey: string;
  setSearchApiKey: (arg0: string) => void;
  selectedSynonymId: string;
  city?: string;
  stateCode?: string;
  yearsOfExperience?: number;
};

export function CareerPathChartHeader({
  formAnalyticsTitle,
  formUsageContext,
  analyticsData,
  careerPathData,
  setCareerPathData,
  salaryModelCreated,
  searchApiKey,
  setSearchApiKey,
  selectedSynonymId,
  city,
  stateCode,
  yearsOfExperience,
}: CareerPathChartHeaderProps) {
  const headingText = getText('Related Salaries');
  const subHeadingText = getText(
    'Add more titles below to compare potential salaries! Questions? {{link}}Contact us.{{/link}}',
  );

  return (
    <CareerPathChartHeaderContainer>
      <H3 mb={0}>{headingText}</H3>
      <BodySmall color={colors.lightContentGrey} mb={0} mt={20}>
        {interpolateComponents({
          mixedString: subHeadingText,
          components: {
            link: <StyledVersionedRouterLink to="/en/about/contact" />,
          },
        })}
      </BodySmall>
      <CareerPathFormContainer>
        <CareerPathForm
          analyticsTitle={formAnalyticsTitle}
          usageContext={formUsageContext}
          analyticsData={analyticsData}
          careerPathData={careerPathData}
          salaryModelCreated={salaryModelCreated}
          setCareerPathData={setCareerPathData}
          searchApiKey={searchApiKey}
          setSearchApiKey={setSearchApiKey}
          selectedSynonymId={selectedSynonymId}
          city={city}
          stateCode={stateCode}
          yearsOfExperience={yearsOfExperience}
        />
      </CareerPathFormContainer>
    </CareerPathChartHeaderContainer>
  );
}
